import { i as h, a as S } from "../type-BFTbooL7.js";
import { a as y, m as d, l as v } from "../common-UUpiO33D.js";
function O(t) {
  return typeof t == "function";
}
function q(t, e) {
  if (h(t) || t.length === 0) {
    const a = (e == null ? void 0 : e.min) ?? 0, i = (e == null ? void 0 : e.max) ?? a + 1;
    return {
      min: a,
      max: i
    };
  }
  let n = [...t];
  S(e) && (n = [...t, e.min, e.max]);
  const r = y(n) ?? 0, o = d(n) ?? r + 5;
  return {
    min: r,
    max: o === r ? r + 5 : o
  };
}
function b(t) {
  if (!(h(t) || t.length < 2))
    return t.map((e, n) => n === 0 ? `M${e.x} ${e.y}` : `L${e.x} ${e.y}`).join(" ");
}
function A(t, e) {
  return e === "exponential" ? Math.exp(t) / Math.exp(1) : e === "log10" ? t === 0 ? 0 : t * Math.log10(t * 10) : e === "sqrt" ? Math.sqrt(t) : e === "cbrt" ? Math.cbrt(t) : t;
}
function z(t, e, n, r = !1, o = "linear") {
  const a = e.max - e.min - (n.start + n.end), i = t.max - t.min;
  return (s) => {
    if (i === 0)
      return t.min;
    const f = (s - t.min) / i, c = A(f, o);
    return r ? a + n.start - a * c : n.start + a * c;
  };
}
function B(t, e) {
  const n = new Date(t);
  n.setDate(1), n.setHours(0, 0, 0, 0);
  const r = new Date(e);
  r.setDate(1), r.setHours(0, 0, 0, 0);
  const o = [];
  for (; n.getTime() <= r.getTime(); )
    o.push(new Date(n)), n.setFullYear(n.getFullYear() + 1), n.setHours(0, 0, 0, 0);
  return o;
}
function L(t, e) {
  const n = new Date(t);
  n.setDate(1), n.setHours(0, 0, 0, 0);
  const r = new Date(e);
  r.setDate(1), r.setHours(0, 0, 0, 0);
  const o = [];
  for (; n.getTime() <= r.getTime(); )
    o.push(new Date(n)), n.setMonth(n.getMonth() + 1), n.setHours(0, 0, 0, 0);
  return o;
}
function T(t) {
  return h(t.x) || h(t.y);
}
function U(t) {
  return h(t) ? void 0 : v(
    t,
    T
  ).map(
    (r) => b(r)
  );
}
function j(t, e = 5) {
  const n = t.max - t.min, r = Math.ceil(n / e), o = t.min + r * e;
  return {
    ...t,
    max: o
  };
}
function M(t) {
  return {
    r: +`0x${t[1]}${t[2]}`,
    g: +`0x${t[3]}${t[4]}`,
    b: +`0x${t[5]}${t[6]}`
  };
}
function m(t) {
  return t.toString(16).padStart(2, "0");
}
function k(t) {
  const { r: e, g: n, b: r } = t;
  return `#${m(e)}${m(n)}${m(r)}`;
}
function C(t) {
  const { h: e, s: n, l: r } = t;
  if (e === 0) {
    const g = Math.round(r * 255);
    return {
      r: g,
      g,
      b: g
    };
  }
  const o = (1 - Math.abs(2 * r - 1)) * n, a = o * (1 - Math.abs(e / 60 % 2 - 1)), i = r - o / 2, s = [
    [o, a, 0],
    [a, o, 0],
    [0, o, a],
    [0, a, o],
    [a, 0, o],
    [o, 0, a]
  ], f = Math.ceil(e / 60) - 1, [c, l, u] = s[f];
  return {
    r: Math.round((c + i) * 255),
    g: Math.round((l + i) * 255),
    b: Math.round((u + i) * 255)
  };
}
function E(t, e, n, r, o) {
  if (t === r) {
    const a = 60 * ((e - n) / o);
    return a > 0 ? a : 360 + a;
  }
  return e === r ? 60 * (2 + (n - t) / o) : n === r ? 60 * (4 + (t - e) / o) : 0;
}
function F(t) {
  const e = M(t), n = e.r / 255, r = e.g / 255, o = e.b / 255, a = Math.min(n, r, o), i = Math.max(n, r, o), s = i - a, c = (i + a) / 2;
  if (s === 0)
    return { h: 0, s: 0, l: c };
  const l = s / Math.abs(1 - (2 * c - 1));
  return { h: E(n, r, o, i, s), s: l, l: c };
}
function x(t, e, n) {
  return Math.min(Math.round(t + (e - t) * n), 255);
}
function I(t, e, n) {
  const r = M(t), o = M(e), a = m(x(r.r, o.r, n)), i = m(x(r.g, o.g, n)), s = m(x(r.b, o.b, n));
  return `#${a}${i}${s}`;
}
function D(t, e) {
  return O(t) ? t(e) : t;
}
function p(t, e, n) {
  if (h(e) && h(n))
    return t;
  const r = F(t), o = C({
    h: r.h,
    s: Math.min(r.s * D(e ?? 1, r.s), 1),
    l: Math.min(r.l * D(n ?? 1, r.l), 1)
  });
  return k(o);
}
function G(t, e) {
  const n = t.max - t.min;
  return (r, o, a) => {
    const i = (r - t.min) / n, s = (e.length - 1) * i, f = Math.floor(s), c = Math.ceil(s);
    if (f === c)
      return p(e[f], o, a);
    const l = (s - f) / (c - f), u = I(
      e[f],
      e[c],
      l
    );
    return p(u, o, a);
  };
}
function J(t, e) {
  if (h(e) || e === 0)
    return [];
  if (e === 1)
    return [t.min];
  const n = (t.max - t.min) / (e - 1);
  return t.max === 0 ? [] : Array.from(Array(e).keys()).map(
    (o) => t.min + n * o
  );
}
function N(t) {
  return {
    left: Math.floor(t / 2),
    right: Math.ceil(t / 2)
  };
}
function R(t, e, n) {
  const r = e - t;
  if (r === 0)
    return {
      left: Math.floor(n / 2),
      right: Math.ceil(n / 2)
    };
  const o = r % n, a = o === 0 ? 0 : n - o;
  return N(a);
}
function K(t, e) {
  const { left: n, right: r } = R(
    t.min,
    t.max,
    e
  );
  return {
    min: t.min - n,
    max: t.max + r
  };
}
function Q({
  chartMargin: t,
  chartPadding: e,
  xAxisHeight: n,
  yAxisWidth: r,
  chartSize: o,
  numXAxisTicks: a
}) {
  const i = t.left + r + e.left, s = t.right + e.right, f = t.top + e.top, c = t.bottom + e.bottom + n, u = (o.width - i - s) / (a + 1), g = Math.max(
    u * (a - 1),
    0
  ), $ = i + u, H = s + u, w = Math.max(
    o.height - f - c,
    0
  );
  return {
    dataAreaSize: {
      width: g,
      height: w
    },
    dataAreaOffset: {
      top: f,
      right: H,
      bottom: c,
      left: $
    }
  };
}
export {
  q as getBounds,
  Q as getChartDimensions,
  G as getColorScaleFunction,
  L as getDatesSeparatedByMonths,
  B as getDatesSeparatedByYear,
  U as getDiscretePathDataList,
  R as getEvenDistribution,
  K as getEvenlyDistributableBounds,
  N as getEvenlyDistributedExcess,
  J as getIntervals,
  b as getPathData,
  j as getPrettyBreakableBounds,
  z as getScaleFunction,
  O as isCallable,
  p as modifyHexSL
};
